import { render } from "./TableBox.vue?vue&type=template&id=73bbe0b6&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"

import "./TableBox.vue?vue&type=style&index=0&id=73bbe0b6&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bbe0b6"]])

export default __exports__